// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3Hsii","actionsCol":"EnrolledClinics_actionsCol__3xheb"};